import React from 'react'
import { SubPageBreadCrumbs } from 'Components/BreadCrumbs'

function index() {
  return (
    <div>
      <SubPageBreadCrumbs />
      Cash Management</div>
  )
}

export default index